// Shared layout tokens for the LX / LXO dashboard surfaces.
// Mirrors the CSS custom properties declared in lxoDashboardTokens.css so the
// MUI `sx` styles and the plain CSS modules stay on a single spacing / sizing
// scale. Keep both files in sync when adjusting values.

export const lxoSpace = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
}

export const lxoRadius = {
  surface: 16,
  control: 12,
}

export const lxoSurface = {
  background: "#FFFFFF",
  border: "1px solid rgba(226,232,240,.7)",
  shadow: "0 4px 16px rgba(15,23,42,.05)",
}

export const lxoFont = {
  sectionTitle: 17,
  cardTitle: 11,
  metric: 26,
  label: 13,
  rowTitle: 13,
  rowSubtitle: 11,
}

// Metric (KPI) card sizing — tuned so the card reads compact while the metric
// number stays prominent.
export const lxoMetricCard = {
  height: 88,
  paddingY: 14,
  paddingX: 16,
  iconSize: 36,
  iconRadius: 10,
  logoSize: 18,
}

// Shared row sizing for My Team, Work Station, and Links cards.
export const lxoSectionRow = {
  height: 52,
  iconSize: 32,
  gap: 10,
  paddingX: 12,
}
